import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { PROMETHEAN_BLUE, PROMETHEAN_NEUTRAL_DARK_GREY, PROMETHEAN_NEUTRAL_GREY_700, PROMETHEAN_NEUTRAL_WHITE, PROMETHEAN_PURPLE_GRAPE, PROMETHEAN_TEXT, PROMETHEAN_TEXT_HEADER, PROMETHEAN_TEXT_INPUT_LABEL, PROMETHEAN_ERROR_OR_DESTRUCT } from '../../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_SUBTITLE_02 } from '../../styles/typography/typography';
import { EmbersMenuLaunchButton } from '../../menu/menuLaunchButton';
export var BasicSelectContainer = styled('div')({
  display: 'inline-flex',
  flexDirection: 'column',
  position: 'relative',
  verticalAlign: 'top',
  width: '100%',
  '&>.MuiButtonBase-root': {
    borderRadius: 4
  }
});
export var StyledBasicSelectLaunchButton = styled(EmbersMenuLaunchButton)(_objectSpread(_objectSpread({
  fieldset: {
    position: 'absolute',
    padding: 0,
    margin: 0,
    top: -8,
    bottom: 0,
    left: 0,
    right: 0,
    borderRadius: 4,
    border: '1px solid ' + PROMETHEAN_NEUTRAL_GREY_700,
    '&.LaunchButton-fieldset-emptyLegend': {
      top: 0
    },
    color: PROMETHEAN_TEXT,
    '&.LaunchButton-fieldset-menuIsOpen': {
      border: '1px solid ' + PROMETHEAN_PURPLE_GRAPE
    },
    '&.LaunchButton-fieldset-disabled': {
      borderColor: PROMETHEAN_NEUTRAL_DARK_GREY,
      color: PROMETHEAN_NEUTRAL_DARK_GREY
    },
    '.LaunchButton-fieldset-requiredPostfix': {
      color: PROMETHEAN_ERROR_OR_DESTRUCT,
      lineHeight: '14px'
    }
  },
  legend: {
    overflow: 'visible',
    textAlign: 'start',
    fontSize: 12,
    lineHeight: '16px',
    paddingLeft: 6,
    paddingRight: 6,
    marginLeft: 8
  },
  cursor: 'pointer',
  height: 48
}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_02), {}, {
  justifyContent: 'flex-start',
  paddingLeft: 16,
  paddingRight: 16,
  backgroundColor: PROMETHEAN_NEUTRAL_WHITE,
  color: PROMETHEAN_TEXT_HEADER,
  '.LaunchButton-text': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_02), {}, {
    color: PROMETHEAN_TEXT_INPUT_LABEL,
    '&.LaunchButton-text-valueSelected': {
      color: PROMETHEAN_TEXT_HEADER
    },
    '&.LaunchButton-text-disabled': {
      color: PROMETHEAN_NEUTRAL_DARK_GREY
    },
    '&:has(.LaunchButton-text-requiredPostfix)': {
      display: 'flex'
    },
    '.LaunchButton-text-requiredPostfix': {
      color: PROMETHEAN_ERROR_OR_DESTRUCT,
      lineHeight: '14px',
      paddingTop: 4
    }
  }),
  '.LaunchButton-arrowIcon': {
    position: 'absolute',
    color: PROMETHEAN_TEXT,
    right: '8px',
    pointerEvents: 'none',
    '&.is-open': {
      transform: 'rotate(180deg)'
    },
    '&.LaunchButton-arrowIcon-disabled': {
      color: PROMETHEAN_NEUTRAL_DARK_GREY
    }
  },
  '&.Mui-focusVisible': {
    fieldset: {
      border: '2px solid ' + PROMETHEAN_BLUE,
      legend: {
        marginLeft: 7,
        paddingBottom: 1
      }
    }
  }
}));